import { render } from "./Datatable.vue?vue&type=template&id=0d44d175&ts=true"
import script from "./Datatable.vue?vue&type=script&lang=ts"
export * from "./Datatable.vue?vue&type=script&lang=ts"

import "./Datatable.vue?vue&type=style&index=0&id=0d44d175&lang=scss"

import exportComponent from "/Users/camp/Desktop/code-time/acampa-gestao-pra/vuecode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__